import { updateLocale } from "moment";
import React, { useEffect, useState } from "react";
import {} from "react-redux";
import { updatePersonalDetailsService } from "../../../../api/services/updatePersonalDetailsService";
import { getAllEmployeeSkills } from "../../../../infra/aggregates/myProfile/skillsSlice";
import { useAppSelector, useAppDispatch } from "../../../../infra/hooks";

interface PropsValues {
  getSkillsData: (data: []) => void;
}

function DTOSkillsDetails({ getSkillsData }: PropsValues) {
  const all_Skills: any = useAppSelector((state) => state.skillsSlice.skills);

  useEffect(() => {
    getSkillsData(all_Skills);
  }, [all_Skills]);

  return <></>;
}
export default DTOSkillsDetails;
